import * as React from 'react';
import cx from 'classnames';
import style from './Wath.css';
import shape from '_images/shape1.svg';

export const Wath = (props) => (
    <section ref={props._ref} className={style.root}>
        <img className={cx(style.shape, style.shape1, 'rotation faster')} src={shape}/>
        <img className={cx(style.shape, style.shape2, 'rotation faster')} src={shape}/>
        <img className={cx(style.shape, style.shape3, 'rotation slower')} src={shape}/>
        <div className={cx(style.content)}>
            <div className="container">
                <h2 className={cx(style.header, 'wow fadeInUp')}>
                    ECONOMIC<br/>
                    SYSTEMS<br/>
                    ENGINEERING
                </h2>
                {/*<p className={cx(style.desc, 'wow', 'fadeInUp')}>*/}
                    {/*BlockScience is&nbsp;a&nbsp;technology research and analytics firm specializing in&nbsp;the design*/}
                    {/*and evaluation of&nbsp;decentralized economic systems. Our focus is&nbsp;to&nbsp;build a&nbsp;bridge*/}
                    {/*that makes the interdisciplinary study of&nbsp;socio-technical networks accessible to&nbsp;new and*/}
                    {/*legacy businesses, allowing them to&nbsp;understand and participate in&nbsp;the emerging*/}
                    {/*decentralized economy enabled by&nbsp;blockchain technology.*/}
                {/*</p>*/}
                {/*<p className={cx(style.desc, 'wow', 'fadeInUp')}>*/}
                    {/*Our work includes pre-launch design and evaluation based on real analysis and simulation. We also*/}
                    {/*provide post launch monitoring, maintenance via reporting, analytics, and decision support software*/}
                    {/*development. Our key priority is the economic health of your decentralized ecosystem.*/}
                {/*</p> */}
                <p className={cx(style.desc, 'wow', 'fadeInUp')}>
                    A new field emerging at the intersection of decision science, game theory, and systems engineering.
                </p>
            </div>
        </div>
    </section>
);